export default function XML_Schema() {
  return (
    <div>
      <h1>XML_Schema</h1>
      <p>This is the XML_Schema component.</p>
    </div>
  );
}